'use strict';

var React = require('react');
var compose = require('../hoc/compose');
var displayNames = require('./displayNames');

var getStyleFromProps = function getStyleFromProps(props) {
    return props.wasVisible ? props.wasVisibleStyle : {};
};

var DropDownOption = function DropDownOption(props) {
    return React.createElement('span', {
        className: props.getClassName('control-dropdown-option-content'),
        value: props.value,
        key: props.key || props.value,
        disabled: props.disabled,
        style: props.wasVisibleStyle ? getStyleFromProps(props) : null,
        'data-aid': props.automationId
    }, props.children && !props.isSelectedElement ? props.children : props.translateIfNeeded(props.label));
};

DropDownOption.displayName = displayNames.DROP_DOWN_OPTION;
DropDownOption.propTypes = {
    value: React.PropTypes.string.isRequired,
    label: React.PropTypes.string.isRequired,
    disabled: React.PropTypes.bool,
    wasVisible: React.PropTypes.bool,
    wasVisibleStyle: React.PropTypes.object
};

DropDownOption.defaultProps = {
    disabled: false
};

module.exports = compose(DropDownOption);


// WEBPACK FOOTER //
// ./~/wix-base-ui/lib/controls/dropDownOption.js